<template>
  <div class="modal-form">
    <b-modal :id="id" :size="size" hide-footer centered>
      <div class="col-12 mb-4">
        <div class="title-modal-history text-left font-weight-bold">
          <img
            class="img-alert-modal mr-2 mb-1"
            src="@/assets/images/icons/eye-line.svg"
            width="15%"
          />
          {{ title }}
        </div>
      </div>
      <div class="col-12 mt-4">
        <slot></slot>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "history-modal",
  props: {
    id: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    size: {
      default: "",
      type: String,
    },
  },
  emits: [],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.title-modal-history {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 24px;
  color: #455a64;
}

.modal-header .close {
  font-weight: 500;
  font-size: 32px;
  text-transform: uppercase;
  color: blue;
}
</style>